"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colorIcons = require("../../../static/icons/colorIcons");

var _style = require("./style");

var arrowIcons = [_colorIcons.COLOR_ICONS.ARROW0STOPS, _colorIcons.COLOR_ICONS.ARROW1STOPS, _colorIcons.COLOR_ICONS.ARROW2STOPS];

var FlightItemStops = function FlightItemStops(_ref) {
  var airportStops = _ref.airportStops,
      airline = _ref.airline,
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? {} : _ref$destination,
      _ref$flightNumbers = _ref.flightNumbers,
      flightNumbers = _ref$flightNumbers === void 0 ? [] : _ref$flightNumbers,
      handleClick = _ref.handleClick,
      icon = _ref.icon,
      maxWidth = _ref.maxWidth,
      _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? {} : _ref$origin,
      _ref$stops = _ref.stops,
      stops = _ref$stops === void 0 ? 0 : _ref$stops,
      operatedBy = _ref.operatedBy,
      stopsText = _ref.stopsText;
  return _react["default"].createElement(_style.Container, {
    "data-test-id": "flightItem",
    maxWidth: maxWidth,
    onClick: handleClick
  }, _react["default"].createElement(_style.Airline, null, _react["default"].createElement(_style.Header, {
    icon: icon
  }, icon, _react["default"].createElement(_style.AirlineName, {
    icon: icon
  }, airline), _react["default"].createElement(_style.Flight, null, " - ".concat(flightNumbers[0])), stopsText && _react["default"].createElement(_style.OperatedBy, {
    left: true
  }, stopsText)), _react["default"].createElement(_style.Row, null, _react["default"].createElement(_style.Column, null, _react["default"].createElement(_style.Time, null, origin.time), _react["default"].createElement(_style.City, null, origin.city)), _react["default"].createElement(_style.ArrowColumn, null, _react["default"].createElement(_style.ArrowIcon, {
    stops: stops > 0,
    size: {
      height: 8,
      width: 152
    },
    icon: arrowIcons[stops],
    viewBox: "0 0 152 8"
  }), _react["default"].createElement(_style.Airports, null, airportStops.map(function (airport, index) {
    return _react["default"].createElement(_style.AirportInfo, null, _react["default"].createElement(_style.Airport, {
      key: airport
    }, airport), _react["default"].createElement(_style.FlightStop, null, flightNumbers[index + 1]));
  }))), _react["default"].createElement(_style.Column, null, _react["default"].createElement(_style.Time, null, destination.time), _react["default"].createElement(_style.City, null, destination.city)))), operatedBy && _react["default"].createElement(_style.OperatedBy, null, operatedBy));
};

FlightItemStops.propTypes = {
  airportStops: _propTypes["default"].arrayOf(_propTypes["default"].string),
  airline: _propTypes["default"].string.isRequired,
  destination: _propTypes["default"].shape({
    city: _propTypes["default"].string,
    time: _propTypes["default"].string
  }).isRequired,
  flightNumbers: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  icon: _propTypes["default"].shape({}),
  handleClick: _propTypes["default"].func.isRequired,
  maxWidth: _propTypes["default"].string,
  origin: _propTypes["default"].shape({
    city: _propTypes["default"].string,
    time: _propTypes["default"].string
  }).isRequired,
  stops: _propTypes["default"].oneOf([0, 1, 2, 3]).isRequired,
  operatedBy: _propTypes["default"].string,
  stopsText: _propTypes["default"].string
};
FlightItemStops.defaultProps = {
  airportStops: [],
  icon: undefined,
  maxWidth: undefined,
  operatedBy: undefined,
  stopsText: undefined
};
var _default = FlightItemStops;
exports["default"] = _default;